import { Card, Divider, Typography } from "antd";
import { displayDollar } from "../../utilities/tableUtility";
import { checkNullPlaceHolder } from "../../utilities/generalUtility";
import K from "../../utilities/constants";
import { StatusTag } from "../../common/components/statusTag/statusTag";

const { Title } = Typography;

export const CandidateJobEntryCard = ({
  jobEntry,
  isActive,
  onClick,
  styles,
}) => {
  return (
    <Card
      key={jobEntry.id}
      className={styles.jobsCardsWrapper}
      bodyStyle={{ width: "100%", background: isActive && "#f7f6ff" }}
      onClick={onClick}
    >
      <div className={styles.jobCardContentWrapper}>
        <div className={styles.jobWrapper}>
          <Title
            title={jobEntry.jobSource.title}
            level={3}
            className={`${styles.jobTitle} hover-underlined`}
          >
            {jobEntry.jobSource.title}
          </Title>

          <div className={styles.locationsList}>
            Client : {jobEntry.jobSource.client?.name}
          </div>
          <div className={styles.locationsList}>
            Location: {jobEntry.jobSource.jobLocation?.name}
          </div>
          <div className={styles.locationsList}>
            Job ATS ID: {checkNullPlaceHolder(jobEntry.jobSource.extAtsId)}
          </div>
          <div className={styles.locationsList}>
            <span className={`${styles.tagesStyle} ${styles.fullTime}`}>
              Desired Salary: {displayDollar(jobEntry.desireSalary)}
            </span>
          </div>
          <div className={styles.locationsList}>
            <span className={`${styles.tagesStyle} ${styles.fullTime}`}>
              Candidate Type:&nbsp;
              {checkNullPlaceHolder(K.CandidateType[jobEntry.hireType])}
            </span>
          </div>
          <div className={styles.locationsList}>
            <span className={`${styles.tagesStyle} ${styles.fullTime}`}>
              Candidate Status: {jobEntry.candidateStatus.name}
            </span>
          </div>
          <div style={{ marginTop: "8px" }}>
            <StatusTag status={jobEntry.status.name} />
            <Divider type="vertical" />
            <StatusTag
              status={jobEntry.subStatus.name}
              parentStatus={jobEntry.status.name}
            />
            {jobEntry?.otherStatus && (
              <>
                <Divider type="vertical" />
                <StatusTag
                  status={jobEntry.otherStatus.name}
                  parentStatus={jobEntry.status.name}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
